import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import {Link as RouterLink} from "react-router-dom";
const Nav = () => {
  return (
    <Container maxWidth="md" >
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{backgroundColor:"rgba(255, 173, 1, 0.4)" , marginTop:"1rem", borderRadius:"15px" }}>
        <Toolbar variant="dense" sx={{ display: "flex" , justifyContent:"space-between"  }}>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 , marginLeft:"1.5rem" }}> 
            <Button component={RouterLink} to="/" sx={{color:"white" , fontFamily:"League Gothic" , fontSize:"25px"}} >       
             Alhussain
            </Button>
          </Typography>
          <Button component={RouterLink} to="/work"   sx={{  display:"flex",justifyContent:'flex-end', color:"white" , fontFamily:"League Gothic" , fontSize:"1.5rem" }}>    
             Work
          </Button>
          <Button href="https://github.com/Omarhussian" sx={{  display:"flex",justifyContent:'flex-end', color:"white" , fontFamily:"League Gothic" , fontSize:"1.5rem"}}>         
             github
          </Button>
        </Toolbar>
      </AppBar>
    </Box>
    </Container>
  );
};
export default Nav;
